import { z } from 'zod';
/**
 * What the /api/geocode endpoint returns to the web app: a flat, normalized
 * shape derived from Mapbox Geocoding (v6) features. We require lat/lng
 * because the address-detail page can't render the map without them; the
 * server enforces that and returns 422 otherwise.
 */
export const GeocodeResult = z.object({
    mapbox_id: z.string(),
    formatted_address: z.string(),
    line1: z.string().nullable(),
    street_name: z.string().nullable(),
    city: z.string().nullable(),
    state: z.string().nullable(),
    postal_code: z.string().nullable(),
    latitude: z.number(),
    longitude: z.number(),
    mapbox_relevance: z.number().min(0).max(1),
});
/**
 * What /api/autocomplete returns per suggestion: a 1:1 projection of the
 * Mapbox Search Box `suggestions[]` shape minus the noise.
 */
export const AutocompleteSuggestion = z.object({
    mapbox_id: z.string(),
    name: z.string(),
    place_formatted: z.string(),
    full_address: z.string(),
});
//# sourceMappingURL=mapbox.js.map